import { ArrowRight, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

const CAL_URL = "https://cal.com/vishwanath-sukumar/25min";
const ASSESSMENT_PATH = "/assessment";

/**
 * Primary call-to-action — drives the "Start your free AI Act audit" flow.
 * Internal route to /assessment. Black filled, large.
 */
export const PrimaryButton = ({
  testId = "primary-cta",
  label = "Start your free AI Act audit",
  to = ASSESSMENT_PATH,
}) => (
  <Link
    data-testid={testId}
    to={to}
    className="btn-primary"
  >
    <span>{label}</span>
    <ArrowRight className="arrow h-4 w-4" strokeWidth={2.25} aria-hidden="true" />
  </Link>
);

/**
 * Secondary CTA — ghost / outline style, smaller, the "or book a call" path.
 * Links externally to Cal.com.
 */
export const SecondaryButton = ({
  testId = "secondary-cta",
  label = "Or book a 20-min call instead",
  className = "",
}) => (
  <a
    data-testid={testId}
    href={CAL_URL}
    target="_blank"
    rel="noopener noreferrer"
    className={`btn-ghost ${className}`}
  >
    <span>{label}</span>
    <ArrowUpRight className="h-3.5 w-3.5" strokeWidth={2.25} aria-hidden="true" />
  </a>
);

/**
 * Compact ghost CTA used in the top nav. Same destination as <SecondaryButton/>
 * but tighter padding for the header bar.
 */
export const NavGhostButton = ({
  testId = "nav-cta",
  label = "Book a 20-min call",
}) => (
  <a
    data-testid={testId}
    href={CAL_URL}
    target="_blank"
    rel="noopener noreferrer"
    className="btn-ghost btn-ghost--sm hidden sm:inline-flex"
  >
    <span>{label}</span>
    <ArrowUpRight className="h-3.5 w-3.5" strokeWidth={2.25} aria-hidden="true" />
  </a>
);

/**
 * Compact filled primary used in the top nav.
 */
export const NavPrimaryButton = ({
  testId = "nav-primary-cta",
  label = "Start free audit",
}) => (
  <Link
    data-testid={testId}
    to={ASSESSMENT_PATH}
    className="btn-primary btn-primary--sm"
  >
    <span>{label}</span>
    <ArrowRight className="h-3.5 w-3.5" strokeWidth={2.25} aria-hidden="true" />
  </Link>
);

export { CAL_URL, ASSESSMENT_PATH };
